import { QUERY_KEYS } from "@/libraries/constant";
import type {
	PutReminderCheckBodySchema,
	ReminderFormFieldSchema,
} from "@/schemas";
import type { PostCreateReminderResponse, ResError } from "@/types";
import { useMutation } from "@tanstack/react-query";

function useReminderMutation() {
	const create = useMutation<
		PostCreateReminderResponse,
		ResError,
		ReminderFormFieldSchema
	>({
		mutationKey: [QUERY_KEYS.MUTATE_REMINDER_CREATE],
	});

	const update = useMutation<
		PostCreateReminderResponse,
		ResError,
		ReminderFormFieldSchema
	>({
		mutationKey: [QUERY_KEYS.MUTATE_REMINDER_UPDATE],
	});

	const checked = useMutation<
		PostCreateReminderResponse,
		ResError,
		PutReminderCheckBodySchema
	>({
		mutationKey: [QUERY_KEYS.MUTATE_REMINDER_CHECK],
	});

	const remove = useMutation<unknown, ResError, number>({
		mutationKey: [QUERY_KEYS.MUTATE_REMINDER_DELETE],
	});

	return { create, update, checked, remove };
}

export default useReminderMutation;
